import LiveTracker from '@/components/member/widgets/LiveTracker';

/**
 * Live Network — platform-wide pool stats + global cycles feed +
 * the member's own most-recent ledger preview. Everything that polls
 * the live-tracker endpoint is scoped to this subpage so the dashboard
 * stays light.
 */
const LiveNetworkSubpage = () => {
  return (
    <div className="space-y-6" data-testid="subpage-live-network">
      <section className="sc-glass-strong rounded-2xl p-5 md:p-6">
        <div className="mb-4">
          <h2 className="font-display font-bold text-xl md:text-2xl">Live Network</h2>
          <p className="text-[13px] text-[var(--sc-text-dim)] mt-1">
            Real-time platform-wide pool metrics, the most recent global cycle events with recipient usernames, and your own latest ledger activity — all
            updating live every 6 seconds.
          </p>
        </div>
        <LiveTracker />
      </section>
    </div>
  );
};

export default LiveNetworkSubpage;
